import { createTheme } from "@mui/material";

import palette from './palette.module.scss';
import { baseTheme } from './base-theme';

export const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: palette.colorPrimaryDarkMode,
      contrastText: '#fff'
    },
    secondary: {
      main: palette.colorSecondary,
      contrastText: '#fff'
    },
    tertiary: {
      main: palette.colorTertiaryDarkMode
    },
    text: {
      primary: palette.colorTextDarkMode,
      disabled: palette.colorTextDisabled
    },
    error: {
      main: palette.colorErrorDarkMode
    },
    success: {
      main: palette.colorSuccessDarkMode,
      contrastText: '#fff'
    },
    warning: {
      main: palette.colorWarningDarkMode,
      contrastText: '#fff'
    },
    light: {
      main: palette.colorLight
    },
    lightGrey: {
      main: palette.colorLightGrey
    },
    background: {
      default: palette.colorBodyBackgroundDarkMode,
      paper: palette.colorLightDarkMode
    }
  },
  components: {
    ...baseTheme.components,
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          '--color-primary': palette.colorPrimaryDarkMode,
          '--color-primary-rgb': palette.colorPrimaryDarkModeRGB,
          '--color-text': palette.colorTextDarkMode,
          '--color-text-rgb': palette.colorTextDarkModeRGB,
          '--color-text-disabled': palette.colorTextDisabled,
          '--color-text-disabled-rgb': palette.colorTextDisabledRGB,
          '--color-secondary': palette.colorSecondary,
          '--color-secondary-rgb': palette.colorSecondaryRGB,
          '--color-tertiary': palette.colorTertiaryDarkMode,
          '--color-tertiary-rgb': palette.colorTertiaryDarkModeRGB,
          '--color-error': palette.colorErrorDarkMode,
          '--color-error-rgb': palette.colorErrorDarkModeRGB,
          '--color-success': palette.colorSuccessDarkMode,
          '--color-success-rgb': palette.colorSuccessDarkModeRGB,
          '--color-warning': palette.colorWarningDarkMode,
          '--color-warning-rgb': palette.colorWarningDarkModeRGB,
          '--color-light': palette.colorLightDarkMode,
          '--color-light-rgb': palette.colorLightDarkModeRGB,
          '--color-lightGrey': palette.colorLightGrey,
          '--color-lightGrey-rgb': palette.colorLightGreyRGB,
          '--color-bodyBackground': palette.colorBodyBackgroundDarkMode,
          '--color-bodyBackground-rgb': palette.colorBodyBackgroundDarkModeRGB,
          '--box-shadow': `
            0 2px 8px rgba(0, 0, 0, 0.3),
            0 1px 1px rgba(255, 255, 255, 0.05),
            0 0 0 1px rgba(59, 120, 215, 0.1)
          `,
          '--border-card': '1px solid rgba(255, 255, 255, 0.05)'
        },
        'input:-webkit-autofill': {
          boxShadow: `0 0 0 100px #266798 inset !important`
        },
        'input:-webkit-autofill:hover': {
          boxShadow: `0 0 0 100px #266798 inset !important`
        },
        'input:-webkit-autofill:focus': {
          boxShadow: `0 0 0 100px #266798 inset !important`
        },
        'input:-webkit-autofill:active': {
          boxShadow: `0 0 0 100px #266798 inset !important`
        }
      }
    },
    MuiPaper: {
      ...baseTheme.components.MuiPaper,
      styleOverrides: {
        ...baseTheme.components.MuiPaper?.styleOverrides,
        root: {
          ...(baseTheme.components.MuiPaper?.styleOverrides?.root as any),
          boxShadow: `var(--box-shadow)`,
          border: 'var(--border-card)',
          backgroundImage: 'none'
        }
      }
    }
  }
});